import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=0518b8ea"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports